import { useCallback } from "react";
import { ColumnsWithGroupData, getColumnsWithGroup } from "../../api/Windows";
import { getCurrentPlant } from "../../util/ApiOptionsHelper";
import { getWorkOrderGroups } from "../../models/workorders/WorkOrder";
import { useWorkOrderStore } from "../../store/wo-order";
import { useLocation } from "react-router";

export default function useGetMetaData() {
  const setMetadata = useWorkOrderStore((state) => state.setWoMetaData);
  const setGroups = useWorkOrderStore((state) => state.setWoGroups);
  const isRequester = useLocation().pathname.includes("requester");

  const getMetaData = useCallback(
    async (woNumber: string) => {
      const workOrder = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      const data: ColumnsWithGroupData = {
        WindowName: isRequester ? "mob_requester_wo_nb" : "mob_wo_nb",
        ContextPKey: {
          Plant: await getCurrentPlant(),
          WoBase: workOrder?.WoBase,
          WoTask: workOrder?.WoTask,
          WoSubtask: workOrder?.WoSubtask,
        },
      };
      const response = await getColumnsWithGroup(data);
      if (!response.isError) {
        setMetadata(woNumber, response.data);
        setGroups(woNumber, getWorkOrderGroups(response.data));
      }
      return response;
    },
    [isRequester, setGroups, setMetadata]
  );

  return { getMetaData };
}
